var BottomGradient      = require("./BottomGradient"),
    CompactHeader       = require("./CompactHeader"),
    CoverVariables      = require("app/theme/styles/covers/CoverVariables"),
    HeaderVariables     = require("app/theme/styles/headers/HeaderVariables"),
    HyperLinkImageSlide = require("app/ui/HyperLinkImageSlide"),
    IconButton          = require("app/ui/IconButton"),
    ImageSlider         = require("app/ui/ImageSlider"),
    Layout              = require("./MediaHeaderLayout"),
    ActionButtons       = require("./ActionButtons"),
    RevolutionSlider    = require("app/ui/RevolutionSlider"),
    VideoSlider         = require("app/ui/VideoSlider"),
    frameThrottle       = require("enyo-perf/utils").frameThrottle,
    get                 = require("object-path").get,
    icons               = require("app/theme/icons"),
    kind                = require("enyo/kind");

require("./MediaHeader.less");
require("app/theme/IconButton--slider.less");

module.exports = kind(/** @lends  app.ui.header.MediaHeader.prototype */ {

    /**
     * @private
     */
    name: "app.ui.header.MediaHeader",

    /**
     * @private
     */
    classes: "app-ui-header-media-header",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * The dataset (should be a media item)
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * @public
     */
    layoutOptions: {

        /**
         * The size of the slider.
         *
         * Possible values:
         * - `default`  Default slides, used for media types which display a
         *              header above a dashboard or a list of serial content.
         * - `tall`     Tall slides, used for media types which display a
         *              viewport-filling headers for non-serial content.
         *
         * @param   {Object}  media  The form-factor
         * @return  {string}  The formFactor of the cover
         * @public
         */
        sliderSize: function() {
            return HeaderVariables.getSliderSize(this.container.get("data") || {});
        },

        /**
         * Some media types show a tall header. If those media items don't have
         * a dashboard, the layout will try to fill the screen. If they do have
         * a dashboard, we want to try and give the user has a peak at the
         * dashboard above the fold.
         *
         * @return  {boolean}  Whether to leave room for a peak at the
         *                     dashboard.
         * @public
         */
        peekAtDashboard: function() {
            var data = this.container.get("data") || {};

            return get(data, "dashboard.length", 0) > 0;
        }
    },

    /**
     * Optional extra options to merge into the slider kind at creation time.
     *
     * @type {Object=}
     * @public
     */
    sliderOptions: null,

    /**
     * The kind that will be rendered as slider buttons.
     *
     * @type {enyo.Control}
     * @public
     */
    sliderButtonKind: IconButton,

    /**
     * Optional extra options to merge into the slider button kind at creation
     * time.
     *
     * @type {Object=}
     * @public
     */
    sliderButtonOptions: null,

    /**
     * The kind that will be rendered as compact header.
     *
     * @type {enyo.Control}
     * @public
     */
    compactHeaderKind: CompactHeader,

    /**
     * Optional extra options to merge into the compact header kind at creation time.
     *
     * @type {Object=}
     * @public
     */
    compactHeaderOptions: null,

    /**
     * The kind that will be rendered as horizontal description.
     *
     * @type {enyo.Control}
     * @public
     */
    horizontalDescriptionKind: null,

    /**
     * Optional extra options to merge into the horizontal description kind at
     * creation time.
     *
     * @type {Object=}
     * @public
     */
    horizontalDescriptionOptions: null,

    /**
     * The kind that will be rendered as vertical description.
     *
     * @type {enyo.Control}
     * @public
     */
    verticalDescriptionKind: null,

    /**
     * Optional extra options to merge into the vertical description kind at
     * creation time.
     *
     * @type {Object=}
     * @public
     */
    verticalDescriptionOptions: null,

    /**
     * The kind that will be rendered as action buttons section.
     *
     * @type {enyo.Control}
     * @public
     */
    actionButtonsKind: ActionButtons,

    /**
     * Optional extra options to merge into the action buttons kind at
     * creation time.
     *
     * @type {Object=}
     * @public
     */
    actionButtonsOptions: null,

    /**
     * The kind that will be rendered as cover.
     *
     * @type {enyo.Control}
     * @public
     */
    coverKind: null,

    /**
     * Optional extra options to merge into the cover kind at creation time.
     *
     * @type {Object=}
     * @public
     */
    coverOptions: null,

    /**
     * The formfactor of the header.
     *
     * Possible values:
     *  - `horizontal`
     *  - `vertical`
     *
     * @type  {string}
     * @private
     */
    formFactor: null,

    /**
     * Whether a slider will be shown.
     *
     * @type  {boolean}
     * @private
     */
    showSlider: false,

    /**
     * Whether a slider will be displaying buttons.
     *
     * @type  {boolean}
     * @private
     */
    showSliderButtons: false,

    /**
     * Whether a compact header will be shown.
     *
     * @type  {boolean}
     * @private
     */
    showCompactHeader: false,

    /**
     * Whether a description will be shown.
     *
     * @type  {boolean}
     * @private
     */
    showDescription: false,

    /**
     * Whether a cover will be shown (requires slider visibility).
     *
     * @type  {boolean}
     * @private
     */
    showCover: false,

    /**
     * The formFactor of the cover.
     *
     * Available options:
     *  - `landscape`
     *  - `square`
     *  - `portrait`
     *  - `null` (no cover)
     *
     * @return   {?string}
     * @default  `null`
     * @public
     */
    coverFormFactor: null,

    /**
     * @private
     */
    handlers: {
        onRequestPreviousSlide: "onRequestPreviousSlide",
        onRequestNextSlide:     "onRequestNextSlide"
    },

    /**
     * @private
     */
    observers: {
        update: ["data", "formFactor"]
    },

    /**
     * @private
     */
    bindings: [{
        from: "formFactor",
        to:   ".$.slider.formFactor"
    }, {
        from: "coverFormFactor",
        to:   ".$.cover.formFactor"
    }],

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    // Component creation
    // --------------------------------
    // Generally we would create components with the `components` property of
    // the kind. In the case of this control there is a wide variety depending
    // on the contents of the `data` property, so we use a pattern of explicitly
    // creating individual controls instead.

    /**
     * Creates a slider control.
     *
     * @param    {Function}      SliderKind  The slider kind constructor
     * @returns  {enyo.Control}  The created component
     * @protected
     */
    createSlider: function(SliderKind) {
        var sliderOptions = this.sliderOptions || {};

        if (SliderKind === ImageSlider) {
            sliderOptions.slideKind   = HyperLinkImageSlide;
            sliderOptions.showButtons = false;
        }

        return this.createComponent({
            name:    "slider",
            kind:    SliderKind,
            classes: "app-ui-header-media-header__slider"
        }, sliderOptions);
    },

    /**
     * Creates a slider button control.
     *
     * @param    {string}        direction  The button direction
     * @returns  {enyo.Control}  The created component
     * @protected
     */
    createSliderButton: function(direction) {
        var name,
            icon,
            cssClass,
            ontap;

        if (direction === "next") {
            name     = "nextSlideButton";
            cssClass = "app-ui-header-media-header__next-slide-button";
            icon     = icons["app.ui.header.MediaHeader.nextSlideButton"];
            ontap    = "onRequestNextSlide";
        }
        else {
            name     = "previousSlideButton";
            cssClass = "app-ui-header-media-header__previous-slide-button";
            icon     = icons["app.ui.header.MediaHeader.previousSlideButton"];
            ontap    = "onRequestPreviousSlide";
        }

        return this.createComponent({
            name:    name,
            kind:    this.sliderButtonKind,
            classes: cssClass,
            theme:   "slider",
            icon:    icon,
            ontap:   ontap
        }, this.sliderButtonOptions);
    },

    /**
     * Creates a gradient to fade the slider into the app background.
     *
     * @returns  {enyo.Control}  The created component
     * @protected
     */
    createBottomGradient: function() {
        return this.createComponent({
            name:    "bottomGradient",
            kind:    BottomGradient,
            classes: "app-ui-header-media-header__bottom-gradient"
        });
    },

    /**
     * Creates a compact header control.
     *
     * @returns  {enyo.Control}  The created component
     * @protected
     */
    createCompactHeader: function() {
        return this.createComponent({
            name:    "compactHeader",
            kind:    this.compactHeaderKind,
            classes: "app-ui-header-media-header__compact-header"
        }, this.compactHeaderOptions);
    },

    /**
     * Creates a horizontal description control.
     *
     * @returns  {enyo.Control}  The created component
     * @protected
     */
    createHorizontalDescription: function() {
        return this.createComponent({
            name:    "horizontalDescription",
            kind:    this.horizontalDescriptionKind,
            classes: "app-ui-header-media-header__horizontal-description"
        }, this.horizontalDescriptionOptions);
    },

    /**
     * Creates a vertical description control.
     *
     * @returns  {enyo.Control}  The created component
     * @protected
     */
    createVerticalDescription: function() {
        return this.createComponent({
            name:    "verticalDescription",
            kind:    this.verticalDescriptionKind,
            classes: "app-ui-header-media-header__vertical-description"
        }, this.verticalDescriptionOptions);
    },

    /**
     * Creates a cover control.
     *
     * @returns  {enyo.Control}  The created component
     * @protected
     */
    createCover: function() {
        return this.createComponent({
            name:    "cover",
            kind:    this.coverKind,
            classes: "app-ui-header-media-header__cover"
        }, this.coverOptions);
    },

    /**
     * Creates a slider overlay for buttons on the bottom-right of the slider.
     *
     * @returns  {enyo.Control}  The created component
     * @protected
     */
    createActionButtons: function() {
        return this.createComponent({
            name:    "actionButtons",
            kind:    this.actionButtonsKind,
            classes: "app-ui-header-media-header__action-buttons"
        }, this.actionButtonsOptions);
    },

    /**
     * @protected
     */
    formFactorChanged: function() {
        this.setAttribute("form-factor", this.formFactor);
    },

    /**
     * @protected
     */
    update: function() {
        var data                   = this.data || {},
            formFactor             = this.formFactor,
            SliderKind             = this.resolveSliderKind(),
            showSliderButtons      = SliderKind === ImageSlider && get(data, "meta.slides.length", 0) > 1,
            showMetaText           = get(data, "show_meta_text", false),
            showCompactHeader      = !SliderKind && showMetaText,
            showDescription        = Boolean(SliderKind) && showMetaText,
            showActionButtons      = Boolean(SliderKind),
            showCover              = this.calcCoverVisibility(SliderKind),
            shouldRender           = this.hasNode(),
            $slider                = this.$.slider,
            $previousSlideButton   = this.$.previousSlideButton,
            $nextSlideButton       = this.$.nextSlideButton,
            $compactHeader         = this.$.compactHeader,
            $horizontalDescription = this.$.horizontalDescription,
            $bottomGradient        = this.$.bottomGradient,
            $verticalDescription   = this.$.verticalDescription,
            $actionButtons         = this.$.actionButtons,
            $cover                 = this.$.cover;

        // Destroy what we don't need
        if ($slider) {
            if (!SliderKind
                || $slider.kindName !== SliderKind.prototype.kindName) {
                $slider.destroy();
                $slider = null;
            }
        }

        if (!showDescription || formFactor !== "horizontal") {
            $bottomGradient && $bottomGradient.destroy();
            $horizontalDescription && $horizontalDescription.destroy();
        }

        if (!showSliderButtons) {
            $previousSlideButton && $previousSlideButton.destroy();
            $nextSlideButton && $nextSlideButton.destroy();
        }

        if (!showActionButtons) {
            $actionButtons && $actionButtons.destroy();
        }

        if (!showCover) {
            $cover && $cover.destroy();
        }

        if (!showDescription || formFactor !== "vertical") {
            $verticalDescription && $verticalDescription.destroy();
        }

        if (!showCompactHeader) {
            $compactHeader && $compactHeader.destroy();
        }

        // Setup what we do need
        if (SliderKind) {
            if (!$slider) {
                $slider = this.createSlider(SliderKind);
            }

            switch (SliderKind) {
                case ImageSlider:
                    $slider.set("data", get(data, "meta.slides", []));
                    break;
                case RevolutionSlider:
                case VideoSlider:
                    $slider.set("state", data);
                    break;
                default:
                    break;
            }

            if (shouldRender && !$slider.hasNode()) {
                $slider.render();
            }
        }

        if (showDescription && formFactor === "horizontal") {
            if (!$bottomGradient) {
                $bottomGradient = this.createBottomGradient();
            }

            if (!$horizontalDescription) {
                $horizontalDescription = this.createHorizontalDescription();
            }
            $horizontalDescription.set("data", data);

            if (shouldRender) {
                !$bottomGradient.hasNode() && $bottomGradient.render();
                !$horizontalDescription.hasNode() && $horizontalDescription.render();
            }
        }

        if (showSliderButtons) {
            if (!$previousSlideButton) {
                $previousSlideButton = this.createSliderButton("previous");
            }

            if (!$nextSlideButton) {
                $nextSlideButton = this.createSliderButton("next");
            }

            if (shouldRender) {
                !$previousSlideButton.hasNode() && $previousSlideButton.render();
                !$nextSlideButton.hasNode() && $nextSlideButton.render();
            }
        }

        if (showActionButtons) {
            if (!$actionButtons) {
                $actionButtons = this.createActionButtons();
            }
            $actionButtons.set("data", data);

            if (shouldRender && !$actionButtons.hasNode()) {
                $actionButtons.render();
            }
        }

        if (showCover) {
            if (!$cover) {
                $cover = this.createCover();
            }
            $cover.set("data", data);

            if (shouldRender && !$cover.hasNode()) {
                $cover.render();
            }
        }

        if (showDescription && formFactor === "vertical") {
            if (!$verticalDescription) {
                $verticalDescription = this.createVerticalDescription();
            }
            $verticalDescription.set("data", data);

            if (shouldRender && !$verticalDescription.hasNode()) {
                $verticalDescription.render();
            }
        }

        if (showCompactHeader) {
            if (!$compactHeader) {
                $compactHeader = this.createCompactHeader();
            }
            $compactHeader.set("data", data);

            if (shouldRender && !$compactHeader.hasNode()) {
                $compactHeader.render();
            }
        }

        // Set flags
        this.set("showSlider", Boolean(SliderKind));
        this.set("showSliderButtons", showSliderButtons);
        this.set("showCompactHeader", showCompactHeader);
        this.set("showDescription", showDescription);
        this.set("showCover", showCover);

        // Media contents can have influence on the layout, so we always reflow.
        this.resize();
    },

    /**
     * Resolves a variety of slider-related properties:
     *  - Which kind of slider, if any, should be shown.
     *  - Whether we should show slider buttons.
     *  - Whether we should show a cover
     *
     * @return  {?enyo.Control}  The slider kind if resolved, `null` otherwise.
     * @private
     */
    resolveSliderKind: function() {
        var mediaItem = this.get("data");

        // No media item
        if (!mediaItem) {
            return null;
        }

        // Slider not enabled
        if (!get(mediaItem, "slide_enabled", true)) {
            return false;
        }

        // Revolution Slider
        if (get(mediaItem, "header_type", null) === "revolution_slider"
            && get(mediaItem, "revolution_slider_url", null)) {
            return RevolutionSlider;
        }

        // Video Slider
        if (get(mediaItem, "header_type", null) === "preview_video"
            && get(mediaItem, "preview_url", null)) {
            return VideoSlider;
        }

        // Image Slider
        if (get(mediaItem, "header_type", null) === "image_slider"
            && get(mediaItem, "meta.slides.length", 0) >= 1) {
            return ImageSlider;
        }

        // No slider
        return null;
    },

    /**
     * Resolves the visibility of the cover.
     *
     * @param   {Function}  SliderKind  The slider kind constructor
     * @return  {boolean}   `true` if cover should be shown, `false` otherwise.
     * @private
     */
    calcCoverVisibility: function(SliderKind) {
        var mediaItem = this.get("data"),
            coverFormFactor,
            coverAspectRatio;

        // No media item
        if (!mediaItem) {
            return false;
        }

        // We don't show covers on top of RevolutionSlider
        if (SliderKind === RevolutionSlider) {
            return false;
        }

        // Slider not enabled
        if (!get(mediaItem, "slide_enabled", true)) {
            return false;
        }

        // Cover not enabled
        if (!get(mediaItem, "cover_enabled", false)) {
            return false;
        }

        coverFormFactor = HeaderVariables.getCoverFormFactor(mediaItem);

        // Cover form factor can't be resolved
        if (!coverFormFactor) {
            return false;
        }

        coverAspectRatio = CoverVariables.getAspectRatio(coverFormFactor);

        // Cover aspect ratio can't be resolved
        if (!coverAspectRatio) {
            return false;
        }

        return true;
    },

    /**
     * @returns  {boolean}  Stop propagation
     * @private
     */
    onRequestPreviousSlide: function() {
        this.$.slider && this.$.slider.triggerHandler("onRequestPreviousSlide");

        return true;
    },

    /**
     * @returns  {boolean}  Stop propagation
     * @private
     */
    onRequestNextSlide: function() {
        this.$.slider && this.$.slider.triggerHandler("onRequestNextSlide");

        return true;
    }

});
